<template>
  <router-view/>
</template>

<style lang="less">
body{background-color: #f5f5f5;}
</style>
